import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var CompanySettingApi = /** @class */ (function () {
    function CompanySettingApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    CompanySettingApi.initialize = function (basePath, fetchApi) {
        if (!CompanySettingApi.instance) {
            CompanySettingApi.instance = new CompanySettingApi(basePath, fetchApi);
        }
        return CompanySettingApi.instance;
    };
    CompanySettingApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1CompanySettingApi(new Configuration(config));
    };
    return CompanySettingApi;
}());
export { CompanySettingApi };
